import { useQuery } from 'react-query'
import request from '../request'
import { User } from '../../lib/types/User'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../store/selectors/userSelector'

export const useGetUserById = (user_id: number | string | undefined) => {
  return useQuery<User, Error>(
    ['user', user_id],
    () =>
      request({
        url: `/user/${user_id}`,
        method: 'GET',
      }).then((res: any) => res.data),
    {
      enabled: !!user_id,
      notifyOnChangeProps: ['data', 'error'],
    },
  )
}
